import "./App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { lazy, Suspense } from "react";
import "./index.css";
import Loader from "./utils/Loader";
// import Leadership from "./pages/Leadership";
import Sustainability from "./pages/Sustainability";
import Strategic from "./pages/Strategic";
import OilGas from "./pages/OilGas";
import GasMonitization from "./pages/GasMonitization";
import EnergyInfrastructure from "./pages/EnergyInfrastructure";

// Lazy imports
const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Affiliate = lazy(() => import("./pages/Affiliate"));
const Contact = lazy(() => import("./pages/Contact"));
// const Industrial = lazy(() => import("./pages/Industrial"));
// const Cases = lazy(() => import("./pages/Cases"));
const PowerPlant = lazy(() => import("./pages/PowerPlant"));
const Member = lazy(() => import("./pages/Member"));
// const CNG = lazy(() => import("./pages/CNG"));
const ErrorPage = lazy(() => import("./utils/ErrorPage"));
const SharedLayout = lazy(() => import("./layouts/SharedLayout"));

const main = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <Suspense fallback={<Loader />}>
          <SharedLayout />
        </Suspense>
      }
    >
      <Route
        index
        element={
          <Suspense fallback={<Loader />}>
            <Home />
          </Suspense>
        }
      />

                 
      <Route
        path="about"
        element={
          <Suspense fallback={<Loader />}>
            <About />
          </Suspense>
        }
      />


      <Route
        path="/affiliate"
        element={
          <Suspense fallback={<Loader />}>
            <Affiliate />
          </Suspense>
        }
      />
      
      {/* <Route
        path="talk-to-an-expert"
        element={
          <Suspense fallback={<Loader />}>
            <TalkToExpertSection />
          </Suspense>
        }
      /> */}


      <Route
        path="member"
        element={
          <Suspense fallback={<Loader />}>
            <Member />
          </Suspense>
        }
      />

      <Route
        path="contact"
        element={
          <Suspense fallback={<Loader />}>
            <Contact />
          </Suspense>
        }
      />
      
      <Route
        path="equipment/gas-generators"
        element={
          <Suspense fallback={<Loader />}>
            <PowerPlant />
          </Suspense>
        }
      />

      <Route
        path="oil-gas-exploration"
        element={
          <Suspense fallback={<Loader />}>
            <OilGas />
          </Suspense>
        }
      />
      <Route
        path="gas-monitization"
        element={
          <Suspense fallback={<Loader />}>
            <GasMonitization />
          </Suspense>
        }
      />
      <Route
        path="energy-infrastructure"
        element={
          <Suspense fallback={<Loader />}>
            <EnergyInfrastructure />
          </Suspense>
        }
      />

      <Route
        path="strategic-parthnership"
        element={
          <Suspense fallback={<Loader />}>
            <Strategic />
          </Suspense>
        }
      />

      <Route
        path="sustainability"
        element={
          <Suspense fallback={<Loader />}>
            <Sustainability />
          </Suspense>
        }
      />
        
           
      <Route
        path="*"
        element={
          <Suspense fallback={<Loader />}>
            <Home />
          </Suspense>
        }
      />
    </Route>
  )
);

function App() {
  return <RouterProvider router={main} />;
}

export default App;
